import ManualList from './ManualList'
export {ManualList}
export default ManualList
